module.exports = __webpack_public_path__ + "static/user-testing-1-mobile-55bcc6756e3242f2f3b2af156fc514ce.jpg";